<div class="row filter-collapse" #filterCollapse>
    <div class="col-12"> 
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label for="classificacao" class="col-form-label">Classificação</label>
                <select class="form-control" name="classificacao" id="classificacao" 
                    [ngModel]="filter.classificacao || ''" (ngModelChange)="filter.classificacao = $event ? $event : null; isFilterDirty = true;">
                    <option value="">Todas as classificações</option>
                    <option *ngFor="let classificacao of classificacoes" [ngValue]="classificacao.id">{{classificacao.nome}}</option>
                </select>  
            </div>            
        </div>         
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label for="estado" class="col-form-label">Estado</label>
                <select class="form-control" name="estado" id="estado"
                   [ngModel]="filter.idEstado || ''" (ngModelChange)="onChangeEstado($event ? $event : null)">
                   <option value="">Todos os estados</option>
                   <option *ngFor="let estado of estados" [ngValue]="estado.id">{{estado.nome}}</option>
               </select>                 
           </div>
           <div class="form-group col-12 col-md-4">
                <label for="regiaoIntermediaria" class="col-form-label">Região Intermediária</label>
                <select class="form-control" name="regiaoIntermediaria" id="regiaoIntermediaria"
                    [ngModel]="filter.idRegiaoGeograficaIntermediaria || ''" (ngModelChange)="onChangeRegiaoIntermediaria($event ? $event : null)"
                    #regiaoIntermediaria="ngModel" [disabled]="!filter.idEstado">
                    <option value="" *ngIf="!filter.idEstado">Selecione o Estado</option>
                    <option value="" *ngIf="filter.idEstado">Todas as regiões</option>
                    <option *ngFor="let regiaoIntermediaria of regioesIntermediarias" [ngValue]="regiaoIntermediaria.id">{{regiaoIntermediaria.nome}}</option>
                </select>                                                           
            </div> 
            <div class="form-group col-12 col-md-4">
                <label for="regiaoImediata" class="col-form-label">Região Imediata</label>
                <select class="form-control" name="regiaoImediata" id="regiaoImediata"
                    [ngModel]="filter.idRegiaoGeograficaImediata || ''" (ngModelChange)="filter.idRegiaoGeograficaImediata = $event ? $event : null"
                    #regiaoImediata="ngModel" [disabled]="!filter.idRegiaoGeograficaIntermediaria">
                    <option value="" *ngIf="!filter.idRegiaoGeograficaIntermediaria">Selecione a região intermediária</option>
                    <option value="" *ngIf="filter.idRegiaoGeograficaIntermediaria">Todas as regiões</option>
                    <option *ngFor="let regiaoImediata of regioesImediatas" [ngValue]="regiaoImediata.id">{{regiaoImediata.nome}}</option>
                </select>                                                           
            </div>                       
        </div>
    </div>
</div>